enum Path {
  user = '/profile/user',
  client = '/profile/client',
  clientKeys = '/profile/client/api-tokens',
}

export const getProfileUserPath = (): string => Path.user;
export const getProfileClientPath = (): string => Path.client;
export const getProfileApiKeyDetailPath = (apiKeyId: string): string => `${ Path.clientKeys }/${ apiKeyId }`;
